import { GQLOrderSourceType, GQLOrderTileFragment } from '@theprintbar/graphql';
import { convertToBrisbaneTime, getDaysUntil, getReadableDateTime } from '../../utils';

export function getOrderTurnaroundStatus(order: GQLOrderTileFragment) {
	const daysRemaining = order.dueDate ? getDaysUntil(order.dueDate) : 0;

	if (daysRemaining === -1) {
		return { className: 'bg-red text-white border-none', text: 'Overdue' };
	} else if (!daysRemaining) {
		return { className: 'bg-orange text-white border-none', text: 'Today' };
	} else {
		return { className: 'bg-green text-blue border-none', text: `${daysRemaining} day${daysRemaining === 1 ? '' : 's'}` };
	}
}

export function getOrderPushToWarehouseDelay(source: 'web' | 'pod' | 'shopify', sameday?: boolean) {
	try {
		if (source !== 'web') return 0;
		if (sameday) return 60 * 60 * 1000; // Delay by 1 hour to allow for changes

		const now = convertToBrisbaneTime(Date.now());
		//8am AEST next day plus the minutes from now aka 4:54 becomes 8:54
		const target = convertToBrisbaneTime(Date.now());
		const mins = now.getUTCMinutes();
		target.setUTCHours(8, mins > 55 ? mins - 5 : mins, now.getUTCSeconds(), now.getUTCMilliseconds());
		if (target <= now) {
			target.setUTCDate(target.getUTCDate() + 1);
		}

		const delay = target.getTime() - now.getTime();
		//Ensure delay is at least 1 hour to allow for changes, even if it's created after 8am
		return Math.max(delay, 60 * 60 * 1000);
	} catch (error) {
		console.error('Error calculating warehouse push delay:', error);
		return 60 * 60 * 1000; // Fallback to 1 hour delay
	}
}
